module.exports = __webpack_public_path__ + "img/play-btn.68d6599b.svg";